import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, FreeMode, Thumbs } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import 'swiper/css/thumbs'
import { useState } from 'react'
import { useRef } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

const ProductImageSwiper = ({ images }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const prevRef = useRef(null)
  const nextRef = useRef(null)

  return (
    <>
      <Swiper
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current
          swiper.params.navigation.nextEl = nextRef.current
          swiper.navigation.init()
          swiper.navigation.update()
        }}
        spaceBetween={10}
        navigation={{
          nextEl: '.carousel--next',
          prevEl: '.carousel--prev',
        }}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="swiper carousel product-details__carousel--main"
      >
        {images.map((element) => {
          return (
            <SwiperSlide className="override-gatsby swiper-slide">
              <GatsbyImage image={element} imgClassName="no-opacity" />
            </SwiperSlide>
          )
        })}
        <div ref={nextRef} className="swiper-button-next product-details__carousel--next"></div>
        <div ref={prevRef} className="swiper-button-prev product-details__carousel--prev"></div>
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="swiper carousel product-details__carousel--thumb mt-3"
      >
        {images.map((element) => {
          return (
            <SwiperSlide className="override-gatsby swiper-slide">
              <GatsbyImage image={element} />{' '}
            </SwiperSlide>
          )
        })}
      </Swiper>
    </>
  )
}

export default ProductImageSwiper
